import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-20 flex h-screen flex-col items-center bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-medium" }, "携帯電話番号", -1)
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, [
  /*#__PURE__*/_createTextVNode(" 確認のためのSMSコードが"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("送られてきます ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-ml" }, "️ 〜機種変等で電話番号を変更された方〜️"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("以前の写真は閲覧できなくなっています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ログインせずに"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "./about",
    class: "font-semibold text-blue-600"
  }, "お問い合わせ"),
  /*#__PURE__*/_createTextVNode("ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("閲覧できるように対応いたします。 ")
], -1)
const _hoisted_7 = ["loading", "disabled"]
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SigninVerifyCode = _resolveComponent("SigninVerifyCode")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["signin", _ctx.user !== null ? 'hidden' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isConfirm)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
            class: "mt-5 space-y-5"
          }, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phoneNumber) = $event)),
                maxlength: "30",
                class: "h-12 w-full rounded border border-gray-800 pl-5 text-lg",
                placeholder: "090-0011-1111"
              }, null, 512), [
                [_vModelText, _ctx.phoneNumber]
              ])
            ]),
            (_ctx.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, k) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: k,
                      class: "text-xl font-semibold text-red-600"
                    }, _toDisplayString(error), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("button", {
              id: "signInButton",
              loading: _ctx.isLoading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSubmit())),
              disabled: _ctx.hasError,
              class: "w-full rounded-md bg-sky-400 py-3 text-center text-2xl font-semibold text-black hover:bg-sky-500 hover:text-white"
            }, _toDisplayString(_ctx.isLoading ? "送信中..." : "送信"), 9, _hoisted_7)
          ], 32))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_SigninVerifyCode, {
              confirmationResult: _ctx.confirmationResult,
              groupId: _ctx.groupId
            }, null, 8, ["confirmationResult", "groupId"])
          ]))
    ])
  ], 2))
}